import {observer} from "mobx-react";
import styled from "styled-components";
import NewsBg from  "/public/assets/images/main/news_bg.png"
import PartneredIcon from "/public/assets/images/main/partnered-ico.png";
import {useStore} from "@/store";
import React, {useEffect, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {getFirstImageSrc} from "@/utils";
import ListLogo from "/public/assets/images/logo/list-inner-logo.png";
import {BsCaretLeftFill, BsCaretRightFill} from "react-icons/bs";
import {SIZES} from "@/components/constants";
import {useRouter} from "next/navigation";
import {useMediaQuery} from "react-responsive";

const NewsWrap = observer(({className}) => {

    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const {contentStore, navigationStore} = useStore();
    const [activeMenuId, setActiveMenuId] = useState(0);
    const [swiperInstance, setSwiperInstance] = useState(null);
    useEffect(() => {
        if(navigationStore.navigateList){
            contentStore.getNewsContentsData(navigationStore.navigateList, "68db664d655492292e882c69").then();
        }
    }, []);
    const router = useRouter();
    return(
        <>
            {
                contentStore.newsGroupList && contentStore.newsGroupList.length > 0 &&
                <NewsWrapInner className={className}>
                    <div className={"info-wrap"}>
                        <div className={"title-wrap"}
                            onClick={() => {
                                router.push("/homepage/news?menu-id=691301d3bb6c9c96a4d5866d");
                            }}
                        >

                            <h2>News</h2>
                            <div className={"icon-wrap test"}><img src={PartneredIcon?.src} alt={"화살표 아이콘"}/></div>
                        </div>
                        <div className="tab-wrap">
                            {
                                contentStore.newsGroupList && contentStore.newsGroupList.length > 0 &&
                                contentStore.newsGroupList.map((item, key) => (
                                    <div
                                        key={key}
                                        className={`tab-item ${key === activeMenuId ? "active" : ""} ${item?.data?.data?.totalCount === 0 ? "none" : ""}`}
                                        onClick={() => {
                                            setActiveMenuId(key)
                                            swiperInstance.slideTo(0, 0);
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                ))}
                        </div>
                        <div className="news-swiper-wrap">
                            {
                                contentStore.newsGroupList?.find((group) => group.menuId === contentStore.newsGroupList[activeMenuId].menuId)?.data?.data?.contents &&
                                contentStore.newsGroupList?.find((group) => group.menuId === contentStore.newsGroupList[activeMenuId].menuId)?.data?.data?.contents.length > 0 ? (
                                        <>
                                            <Swiper
                                                slidesPerView={!isTablet ? 3.8 : 1.3}
                                                spaceBetween={!isTablet ? 16 : 8}
                                                modules={[Navigation, Pagination]}
                                                observer={true}
                                                observeParents={true}
                                                loop={false}
                                                navigation={{
                                                    nextEl: ".news-swiper-controls-inner .news-swiper-next",
                                                    prevEl: ".news-swiper-controls-inner .news-swiper-prev",
                                                }}
                                                pagination={{
                                                    el: ".news-swiper-controls-inner .news-swiper-pagination",
                                                    type: "progressbar",
                                                }}
                                                slidesOffsetBefore={!isTablet ? 300 : 25}
                                                slidesOffsetAfter={!isTablet ? 300 : 25}
                                                onSwiper={setSwiperInstance}
                                            >
                                                {contentStore.newsGroupList?.find((group) => group.menuId === contentStore.newsGroupList[activeMenuId].menuId)?.data?.data?.contents.map((item) => (
                                                    <SwiperSlide key={item._id}>
                                                        <div className="news-item" onClick={() => {
                                                            router.push(`/homepage/management/detail?menu-id=${item.menuId}&content-id=${item._id}&content-type=gallery`);
                                                        }}>
                                                            <div className={"text-inner"}>
                                                                <div className="news-classification">{item.data.classification}</div>
                                                                <div className="news-title">{item.data.title}</div>
                                                            </div>
                                                            <div className={"thumb"}>
                                                                {
                                                                    item.data.listContent && getFirstImageSrc(item.data.listContent) ?
                                                                        <img src={getFirstImageSrc(item.data.listContent)}/> :
                                                                        <img src={ListLogo?.src}/>
                                                                }
                                                            </div>

                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                            <div className="news-swiper-controls">
                                                <div className={"news-swiper-controls-inner"}>
                                                    <div className="news-swiper-prev"><BsCaretLeftFill size={15}
                                                                                                       color={"#fff"}/><span>PREV</span>
                                                    </div>
                                                    <div className="news-swiper-pagination"/>
                                                    <div className="news-swiper-next"><span>Next</span><BsCaretRightFill
                                                        size={15} color={"#fff"}/></div>
                                                </div>
                                            </div>
                                        </>
                                ) : (
                                    <div className="empty">등록된 소식이 없습니다.</div>
                                )}

                        </div>
                    </div>
                </NewsWrapInner>
            }
        </>
    )
});
const NewsWrapInner = styled.div`
    background: url(${NewsBg?.src}) no-repeat center / cover;
    padding: 140px 0 190px;

    .info-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title-wrap {
            display: flex;
            align-items: center;
            transition: all 1.5s;
            opacity: 0;
            transform: translate(0, 40px);
            cursor: pointer;

            h2 {
                font-weight: 700;
                font-size: 48px;
                line-height: 100%;
                text-align: center;
                letter-spacing: -0.02em;
                color: #FFFFFF;
                transition: all .15s;
                transform: translateX(16px);
            }
            

            .icon-wrap {
                margin-left: 16px;
                width: 24px;
                transform: translateX(-20px);
                opacity: 0;
                transition: all .15s;
            }
            &:hover{
                h2 {
                    transform: translateX(0);
                }
                .icon-wrap{
                    opacity: 1;
                    transform: translateX(0);
                }
            }
        }
    }
    &.active {
        .title-wrap {
            opacity: 1;
            transform: translate(0);
        }
    }
    .tab-wrap{
        display: flex;
        align-items: center;
        gap: 32px;
        justify-content: center;
        margin: 30px 0 50px;
        .tab-item{
            font-weight: 700;
            font-size: 24px;
            line-height: 100%;
            color: #CCCCCC;
            cursor: pointer;
            &.active{
                color: #fff;
            }
            &.none{
                display: none;
            }
        }
    }
    
    .news-swiper-wrap{
        width: 100%;
        .swiper{
            width: 100%;
            //padding: 0 150px;
        }
        .swiper-slide{
            height: 424px;
            border-radius: 20px;
            overflow: hidden;
            cursor: pointer;
            .news-item{
                transition: all .3s ease-in-out;
                background: #23203B;
                padding: 40px;
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: space-between;
                .text-inner{
                    .news-classification{
                        font-weight: 700;
                        font-size: 14px;
                        line-height: 14px;
                        display: flex;
                        align-items: center;
                        color: #7AB3FB;
                    }
                    .news-title{
                        margin-top: 20px;
                        font-weight: 600;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: -0.02em;
                        color: #FFFFFF;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
                .thumb{
                    width: 100%;
                    //width: 230px;
                    height: 230px;
                    overflow: hidden;
                    border-radius: 10px;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            &:hover{
                .news-item{
                    background: #4939B1;    
                }
            }
        }
        .news-swiper-controls{
            
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 84px;
            .news-swiper-controls-inner{
                width: 900px;
                display: flex;
                align-items: center;
                gap: 30px;
                .news-swiper-prev,
                .news-swiper-next{
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    span{
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: 0.02em;
                        color: #FFFFFF;
                    }
                    cursor: pointer;
                }
                .news-swiper-pagination{
                    position: relative;
                    inset: auto;
                    height: 2px;
                    background-color: rgba(0,0,0, .2);
                    .swiper-pagination-progressbar-fill{
                        background-color: #fff;
                    }
                }
            }

        }
        .empty{
            color: #fff;
            text-align: center;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 110px 0 120px;
        .info-wrap {
            .title-wrap {
                h2 {
                    font-weight: 700;
                    font-size: 32px;
                    line-height: 100%;
                    letter-spacing: -0.02em;
                    color: #FFFFFF;
                    transform: translateX(0);
                }
                .icon-wrap {
                    width: 20px;
                    margin-left: 7px;
                    transform: translateX(0);
                    opacity: 1;
                }
            }
        }
        .tab-wrap{
            display: flex;
            align-items: center;
            gap: 28px;
            justify-content: center;
            margin: 30px 0 50px;
            .tab-item{
                font-size: 16px;
                cursor: pointer;
                &.active{
                    color: #fff;
                }
            }
        }
        .news-swiper-wrap{
            .swiper-slide{
                height: 350px;
                border-radius: 20px;
                overflow: hidden;
                cursor: pointer;
                .news-item{
                    transition: all .3s ease-in-out;
                    background: #F3F2F9;
                    padding: 40px 20px;
                    display: flex;
                    height: 100%;
                    flex-direction: column;
                    justify-content: space-between;
                    .text-inner{
                        .news-classification{
                            font-size: 14px;
                            line-height: 14px;
                        }
                        .news-title{
                            font-size: 18px;
                            line-height: 120%;
                            color: #333333;
                        }
                    }
                    .thumb{
                        width: 100%;
                        //width: 230px;
                        height: 180px;
                        overflow: hidden;
                        border-radius: 10px;
                        img{
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
                &:hover{
                    .news-item{
                        background: #F3F2F9;
                    }
                }
            }
            .news-swiper-controls{
                margin-top: 40px;
                .news-swiper-controls-inner{
                    width: 100%;
                    padding: 0 35px;
                    display: flex;
                    align-items: center;
                    gap: 30px;
                    position: relative;
                    .news-swiper-prev{
                        position: absolute;
                        top: 30px;
                        left: 35px;
                    }
                    .news-swiper-next{
                        position: absolute;
                        top: 30px;
                        right: 35px;
                    }
                }

            }
        }
    }
    
`
export default NewsWrap